import React, { useMemo } from 'react'
import { actionAtom } from 'atoms/atoms'
import { useAtomValue } from 'jotai'
import { Sheet } from '@node-space/ui-components'
import EditCompanyProfile from 'pages/CompanyProfile/components/EditCompanyProfile'
import { ActionIds } from 'types/types'
import { DiscoverNetworkMembers } from './components/DiscoverNetworkMembers'

interface BvnkNetworkSheetProps {
  isSheetOpen: boolean
}

export const BvnkNetworkSheet = ({ isSheetOpen }: BvnkNetworkSheetProps) => {
  const action = useAtomValue(actionAtom)
  const { onBack, onClose, header, subHeader } = action || {}

  const sheetContent = useMemo(() => {
    switch (action?.actionId) {
      case ActionIds.NETWORK_DISCOVER_MEMBERS:
        return <DiscoverNetworkMembers />
      case ActionIds.NETWORK_EDIT_COMPANY:
        return <EditCompanyProfile description={action?.meta?.companyDetails?.description} />
      default:
        return null
    }
  }, [action])

  return (
    <Sheet
      header={header}
      onBack={onBack}
      isOpen={isSheetOpen}
      onClose={onClose}
      subHeader={subHeader}
    >
      {sheetContent}
    </Sheet>
  )
}
